<mat-progress-bar
    class="loading__progress-bar"
    mode="indeterminate"
    *ngIf="loading"
  ></mat-progress-bar>
  
<div class="flex-row">
  <div class="col-6 p-0 m-0">
    <h4 class="text-black-alpha-80 px-4 pt-4"><b>{{ data.header }} Payment</b></h4>
  </div>
  <div class="col-6 p-0 m-0 text-end">
    <i class="pi pi-times p-4 cursor-pointer close-icon" mat-dialog-close></i>
  </div>
</div>

<form [formGroup]="paymentFormGroup">
  <mat-dialog-content>    
    <p class="text-black-alpha-90">Ensure your paymenty information is accurate before saving.</p>
    <div class="flex-row pt-3">
      <div class="col-6 pl-0 py-0">
        <h5 class="text-theme-color">Nominated Payment Type</h5>
        <mat-form-field class="flex">
          <mat-label>Payout Account Type</mat-label>
          <mat-select required formControlName="payoutAccountType" [(value)]="selectedPayoutAccountTypeValue" (selectionChange)="onSelectPayoutAccountType()">
            <mat-option *ngFor="let payoutAccountType of payoutAccountTypes" [value]="payoutAccountType.value">
              {{ payoutAccountType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="selectedPayoutAccountTypeValue <= 0">Payout account type is required.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="flex-row">
      <div class="col-6 pl-0 py-0">
        <h5 class="text-theme-color">Payment Details</h5>
        <mat-form-field class="flex">
          <mat-label>Bank Name</mat-label>
          <mat-select required formControlName="bankName" [(value)]="selectedPaymentMethodValue">
            <mat-option *ngFor="let paymentType of paymentMethods" [value]="paymentType.value">
              {{ paymentType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="selectedPaymentMethodValue <= 0">Bank name is required.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="flex-row">
      <div class="col-6 pl-0 py-0">
        <mat-form-field class="flex">
          <mat-label>Account Name</mat-label>
          <input matInput placeholder="Account Name" formControlName="accountName">
          <mat-error *ngIf="paymentFormGroup.get('accountName')?.hasError('required')">
            Account name is required.
          </mat-error>
          <mat-error *ngIf="paymentFormGroup.get('accountName')?.hasError('pattern')">
            Only letters, numbers, and spaces allowed. Max 50 characters.
          </mat-error>
          
          <mat-error *ngIf="paymentFormGroup.get('accountName')?.hasError('onlyNumbers')">
            Account name must include letters (cannot be numbers only).
          </mat-error>
          
          <mat-error *ngIf="paymentFormGroup.get('accountName')?.hasError('onlySpaces')">
            Account name cannot be just spaces.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-6 pl-0 py-0">
        <mat-form-field class="flex">
          <mat-label>Account Number</mat-label>
          <input matInput type="number" maxlength="12" placeholder="Account Number" #accountNo formControlName="accountNo" class="no-arrows">
          <mat-hint align="end">{{accountNo.value.length}} / 12</mat-hint>
          <mat-error *ngIf="accountNo.value.length <= 0">Account number is required.</mat-error>
          <mat-error *ngIf="accountNo.value.length > 0 && accountNo.value.length <= 9">Account number is invalid.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <small class="mt20">Required form labels ends with an *</small>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="p-4">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button class="text-white" color="primary" class="btn-white" (click)="savePaymentMethod()" [disabled]="paymentFormGroup.invalid || loading">{{ data.header }} Payment Method</button>
  </mat-dialog-actions>
</form>
